"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalPage = exports.Page = void 0;
var log_1 = require("../utils/log");
var utils_1 = require("../utils/utils");
var Slot_1 = __importDefault(require("./Slot"));
var Analytics_1 = require("./Analytics");
var Page = /** @class */ (function () {
    function Page() {
        this.slots = {};
        this.isTabActive = true;
        this.page_analytics_logged = false;
    }
    Page.prototype.init = function () {
        // generate page id
        this.id = (0, utils_1.generateUUID)();
        // detect viewport width change
        this.detectViewportWidthChange();
        // send page data to server
        Analytics_1.globalAnalytics.sendSessionPageAnalytics();
    };
    /**
     * Build slots
     * @param slots
     * @description Build slots from config
     * @returns void
     */
    Page.prototype.buildSlots = function (slots) {
        // loop through slots
        for (var slotName in slots) {
            // get slot config
            var slotConfig = slots[slotName];
            // search page for slot
            var element = this.searchPageDomForSlot(slotConfig.css_selector);
            // If slot found
            if (element instanceof HTMLElement) {
                // set reference element
                slotConfig.referenceElement = element;
                // create slot
                var slot = new Slot_1.default(slotConfig);
                // build slot
                if (slot.buildSlot()) {
                    // add slot to page
                    this.slots[slot.name] = slot;
                }
            }
        }
    };
    /**
     * Search page for slot
     * @param css_selector
     * @returns Element | boolean
     * @description Search page for slot by css selector
     */
    Page.prototype.searchPageDomForSlot = function (css_selector) {
        var elements = document.querySelectorAll("".concat(css_selector, ":not(.bigcrunch-unit-injected)"));
        if (elements.length) {
            if (elements.length > 1) {
                (0, log_1.logWarn)('Multiple elements found for selector: ' + css_selector);
            }
            var element = elements[0];
            return element;
        }
        return false;
    };
    /**
     * Detect when viewport width changes
     */
    Page.prototype.detectViewportWidthChange = function () {
        var _this = this;
        var width = (0, utils_1.getPageWidth)();
        window.addEventListener('resize', function () {
            if (width !== (0, utils_1.getPageWidth)()) {
                // loop through slots and update sizes array for each slot
                for (var slotName in _this.slots) {
                    var slot = _this.slots[slotName];
                    if (slot instanceof Slot_1.default) {
                        slot.setSizes();
                    }
                }
            }
        });
    };
    Page.prototype.handleTabVisabilityStateChange = function (isTabActive) {
        this.isTabActive = isTabActive;
        // loop through slots
        for (var slotName in this.slots) {
            var slot = this.slots[slotName];
            if (slot instanceof Slot_1.default) {
                if (!this.isTabActive) {
                    slot.handleViewabilityChange(this.isTabActive);
                    slot.removeViewabilityTracker();
                    slot.removeLazyloadTrackers();
                }
                else {
                    slot.setViewabilityTracker();
                    slot.setLazyLoadTrackers();
                }
            }
        }
    };
    return Page;
}());
exports.Page = Page;
exports.globalPage = new Page();
